import { VISIT_TABS_INDEX } from '../../../redux/slices/visitsSlice';
import { VisitaEstado } from './visitasStatus';

// Las visitas de un establecimiento dado de baja son solo de consulta: el menú de
// Acciones ofrece Ver visita, Ver historial y las descargas, y ninguna acción de
// gestión (SMP-513). El dato lo informa Back-APIVisitas en cada visita.
export const esDeEstablecimientoDadoDeBaja = (visita: any): boolean =>
    visita?.establecimiento?.dadoDeBaja === true;

// Pestaña de la grilla a la que pertenece una visita según su estado. La solapa
// "Todas" la usa para aplicar a cada fila las reglas de su pestaña propia.
export const resolveVisitTabIndexByEstado = (estado?: number | null): VISIT_TABS_INDEX | null => {
    switch (estado) {
        case VisitaEstado.SIN_ASIGNAR:
        case VisitaEstado.RECHAZADO:
            return VISIT_TABS_INDEX.REJECTED;
        case VisitaEstado.PENDIENTE:
            return VISIT_TABS_INDEX.PENDING;
        case VisitaEstado.PROGRAMADA:
            return VISIT_TABS_INDEX.PROGRAMMED;
        case VisitaEstado.EN_PROCESO:
            return VISIT_TABS_INDEX.IN_PROGRESS;
        case VisitaEstado.REALIZADA:
            return VISIT_TABS_INDEX.IN_REVISION;
        case VisitaEstado.FALLIDA:
        case VisitaEstado.CANCELADA:
        case VisitaEstado.PRESENTADO:
            return VISIT_TABS_INDEX.CLOSED;
        default:
            return null;
    }
};

const SEE_EXECUTION_VISIT_TABS = [
    VISIT_TABS_INDEX.PROGRAMMED,
    VISIT_TABS_INDEX.IN_PROGRESS,
    VISIT_TABS_INDEX.IN_REVISION,
    VISIT_TABS_INDEX.CLOSED
];

interface RolesVerVisita {
    isAdminBO?: boolean;
    isViewerBO?: boolean;
    isPreventor?: boolean;
    isSupervisorSIMP?: boolean;
}

// "Ver visita" (pantalla de ejecución) según el perfil y la pestaña de la visita.
// La usan la grilla de Visitas y el resumen del establecimiento, que tienen que
// ofrecerla igual (SMP-513).
export const puedeVerEjecucionVisita = (
    visita: any,
    tabIndex: VISIT_TABS_INDEX | null,
    { isAdminBO, isViewerBO, isPreventor, isSupervisorSIMP }: RolesVerVisita
): boolean => {
    const enPestanaConEjecucion =
        visita?.estado !== undefined &&
        tabIndex !== null &&
        SEE_EXECUTION_VISIT_TABS.includes(tabIndex);

    const enRevisionOCerrada =
        visita?.estado !== undefined &&
        tabIndex !== null &&
        [VISIT_TABS_INDEX.IN_REVISION, VISIT_TABS_INDEX.CLOSED].includes(tabIndex);

    return (
        (Boolean(isAdminBO) && enPestanaConEjecucion) ||
        (Boolean(isPreventor) && enRevisionOCerrada) ||
        (Boolean(isViewerBO) && enPestanaConEjecucion) ||
        // El supervisor ve la ejecución de las visitas Presentadas en solo lectura (SMP-459).
        (Boolean(isSupervisorSIMP) && visita?.estado === VisitaEstado.PRESENTADO)
    );
};
